import DeleteTermModal from "./DeleteTermModal";

const DeleteTagModal = ({ modalDetails }) => (
  <DeleteTermModal modalDetails={modalDetails} kind="tag" />
);

export default DeleteTagModal;
